import React from 'react';
import ElementIcon, { Icons } from 'src/components/ElementIcon/ElementIcon';
import { striked } from 'src/components/LandingPage/ServicePlans/ServicePlans.module.scss';

export const BooleanField = ({ value, className = '', colSpan = 1 }) => (
  <td colSpan={colSpan} style={{ textAlign: 'center' }} className={`${value === 'true' ? '' : striked} ${className}`}>
    {value === 'true' ? <ElementIcon icon={Icons.pipe} /> : null}
  </td>
);
